// extracted by mini-css-extract-plugin
export default {"title":"UpdLastSent_title__JWmC3","description":"UpdLastSent_description__KjyD2"};